<template>
  <companyEdit :new="true"/>
</template>

<script>
import companyEdit from '@/components/companies/companyEdit'

export default {
name: 'companiesNewPage',

components: {
  companyEdit
}

}
</script>